import { css } from "@emotion/react";
import { Theme } from "@mui/material";

export const contactMenuStyles = {
  seeAllLinkStyles: (theme: Theme) =>
    css({
      ".MuiTypography-root": {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightSemiBold,
      },
    }),
  subheader: {
    backgroundColor: "inherit",
  },
};
